import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PopUp } from '@components/PopUp'

import { SequenceLibrary, SequenceTemplate } from '@types'

import { SequenceTemplateList } from './SequenceTemplateList'

import { Container } from './PopUpImportSequenceTemplate.styled'

interface Props {
  onSubmit: (sequence: SequenceTemplate | SequenceLibrary) => void
  onClose: () => void
}

export const PopUpImportSequenceTemplate = (props: Props): JSX.Element => {
  const { onSubmit, onClose } = props

  const { t } = useTranslation()

  const [selectedSequence, setSelectedSequence] = useState<SequenceTemplate | SequenceLibrary | undefined>()

  return (
    <PopUp
      title={t('modules_project-settings_components_PopUpImportSequenceTemplate_title')}
      onSubmitLabel={t('modules_project-settings_components_PopUpImportSequenceTemplate_import_label')}
      onClose={onClose}
      onSubmit={() => {
        if (selectedSequence) {
          onSubmit(selectedSequence)
        }
      }}
    >
      <Container>
        <SequenceTemplateList selected={selectedSequence} onClick={setSelectedSequence} />
      </Container>
    </PopUp>
  )
}
